import { captureWorkbookSheet } from '../../../global/grid-export';

export const exportSummaryToExcel = async (gridEntries, fileName = null) => {
    const sheets = [];

    for (const entry of gridEntries) {
        if (entry.sheet) {
            sheets.push(entry.sheet);
        } else if (entry.buildSheet) {
            const sheet = await entry.buildSheet();
            if (sheet) sheets.push(sheet);
        } else if (entry.grid) {
            sheets.push(await captureWorkbookSheet(entry.grid, entry.sheetName));
        }
    }

    const workbook = new kendo.ooxml.Workbook({ sheets });
    const dataURI = await workbook.toDataURLAsync();
    const now = new Date();
    const stamp = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}`;
    kendo.saveAs({ dataURI, fileName: fileName ?? `ScheduleFiveOverview_${stamp}.xlsx` });
};
